import React from 'react';
import { t } from '../../../../../../../shared/components/l10n/l10n';
import NovemberFirstLogo from '../../../assets/N1_Logo.svg';

const ModalFooter = () => {
    return (
        <div className="mt-8">
            <div className="absolute left-0 w-full border-grey-dark" style={{ borderTopWidth: '3px', bottom: '58px' }}></div>
            <div className="flex items-center">
                {t`SMARTPAY_ONBOARDING_MODAL_DELIVERED_BY`}
                <img src={NovemberFirstLogo} alt="November First logo" className="h-3 ml-2" />
            </div>
        </div>
    );
};

export default ModalFooter;
